import { render } from "./PaymentFeedback.vue?vue&type=template&id=0167dcc5"
import script from "./PaymentFeedback.vue?vue&type=script&lang=js"
export * from "./PaymentFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__